import React from "react";
import "./search.css";
import { FaSearch } from "react-icons/fa";

const Search = ({ search, handleChange }) => {
  return (
    <div className="containerSearch">
      <div className="searchTitle">Search Blogs</div>
      <div className="search-field">
        <input
          type="text"
          placeholder="Search by title, description, or tags..."
          value={search}
          onChange={handleChange}
        />
        <FaSearch className="search-icon" />
      </div>
      {search && (
        <div className="search-hint">
          Searching for: <strong>{search}</strong>
        </div>
      )}
    </div>
  );
};

export default Search;
